export default __webpack_public_path__ + "static/media/mongodb.41ae1969.png";